export const VIVALDI = 'VIVALDI';
export const BUBBLY = 'BUBBLY';
export const SIREN = 'SIREN';
export const TRIPLET = 'TRIPLET';
export const ALLEGRO = 'ALLEGRO';
export const CRESCENDO = 'CRESCENDO';
export const DISABLED = 'DISABLED';
